module.exports = __webpack_public_path__ + "img/adam.8dc7f08b.png";